import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Browser, List, Page } from '../../utils/Layout/Layout';
import ListComponent from '../../utils/ListComponent/ListComponent';
import { useTorgaContext } from '../TorgaContext';
import { ObjectTypes, urlToEquipmentID } from '../TorgaRouter';
import Equipment from './Equipment';
import { actionEquipmentCreate } from './actions';

export default function Equipments() {
  const { state, dispatchAction } = useTorgaContext();
  const navigate = useNavigate();
  const params = useParams();

  const equipments = state.equipments.allIDs
    .map((id) => state.equipments.byID[id])
    .filter(Boolean)
    .filter((equipment) => !equipment.deleted);

  React.useEffect(() => {
    if (!params.id && equipments.length > 0) {
      navigate(urlToEquipmentID(equipments[0].id), { replace: true });
    }
  }, [params.id, equipments.length]);

  return (
    <Browser>
      <List>
        <ListComponent
          objectType={ObjectTypes.EQUIPMENTS}
          values={equipments}
          render={(equipment) => [equipment.name || '(unnamed equipment)']}
          onClick={(id) => navigate(urlToEquipmentID(id))}
          quickentry={{ placeholder: 'Add new equipment' }}
          onCreate={(name) => dispatchAction(actionEquipmentCreate(name))}
        />
      </List>
      <Page>
        <Equipment />
      </Page>
    </Browser>
  );
}
